// extracted by mini-css-extract-plugin
module.exports = {"container":"content-with-icon_container__XXBcO"};